

import { Button, Card, CardActions, CardContent, Collapse, List, useTheme } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IObjectAttributeValue } from "../../../services/attribute-data-service/Models";
import { AttributeSchemaUsageListItem } from "./AttributeSchemaUsageListItem";
import { useState } from "react";

export type AttributeSchemaUsageCardProps = {
    title: string,
    items: IObjectAttributeValue[],
};

export function AttributeSchemaUsageCard({
    title,
    items,
}: AttributeSchemaUsageCardProps) {

    const [usageExpanded, setUsageExpanded] = useState(false);
    
    const theme = useTheme();

    return (

        <Card variant="outlined" 
            sx={{
                backgroundColor: "custom.background.cardContainer",
                marginBottom: 1
                }}>

            <CardActions sx={{ paddingTop: 0, paddingBottom: 0 }}>

                <Button
                    sx={{
                        color: "text.primary"
                    }}
                    variant="text"
                    onClick={() => { setUsageExpanded(!usageExpanded)}
                    }
                    style={{ marginLeft: "auto" }}
                    endIcon={<ExpandMoreIcon sx={{
                        transform: !usageExpanded ? "rotate(0deg)" : "rotate(180deg)",
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shortest,
                        })
                    }} />}
                >
                    {`${title} [${items.length}]`}
                </Button>
            </CardActions>



            <Collapse in={usageExpanded} timeout="auto">
                <CardContent sx={{
                    padding: '0!important',
                    margin: (theme) => `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} !important`,
                    minHeight: theme.spacing(4),
                    overflow: 'hidden',
                }}>


                    <List sx={{
                        paddingTop: 0,
                        overflowX: "hidden",
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '1 1 auto'        
                    }}>

                        {items.sort((a, b) => (a.object.displayText ?? '').localeCompare(b.object.displayText ?? ''))?.map((o, index) =>

                            <AttributeSchemaUsageListItem 
                                key={index} 
                                item={o} 
                            />
                        )}                                      
                    </List>

                </CardContent>
            </Collapse>

        </Card>
    );
}
